/**
 * API 接口调用模块
 * 对 utils.js 中的 HTTP 方法进行封装，提供语义化的接口调用方法
 */
import { get, post, deletes, patch, put } from "./utils"

/**
 * 发送 GET 请求
 * @param {string} url - 接口地址
 * @returns {Promise} 响应数据
 */
function fetchData(url) {
  return get(url, null)
}

/**
 * 发送 POST 请求
 * @param {string} url - 接口地址
 * @param {object} data - 请求体数据
 * @returns {Promise} 响应数据
 */
function postData(url, data) {
  return post(url, data, null)
}

/**
 * 发送 DELETE 请求
 * @param {string} url - 接口地址
 * @returns {Promise} 响应数据
 */
function deleteData(url) {
  return deletes(url, null)
}

/**
 * 发送 PATCH 请求
 * @param {string} url - 接口地址
 * @param {object} data - 请求体数据
 * @returns {Promise} 响应数据
 */
function patchData(url, data) {
  return patch(url, data, null)
}

/**
 * 发送 PUT 请求
 * @param {string} url - 接口地址
 * @param {object} data - 请求体数据
 * @returns {Promise} 响应数据
 */
function putData(url, data) {
  return put(url, data, null)
}

export default {
  fetchData,
  postData,
  deleteData,
  patchData,
  putData
}



// WEBPACK FOOTER //
// ./src/utils/api.js